import React, { useCallback } from "react";
import { useHistory } from "react-router-dom";

import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import { ReactComponent as PortfolioIcon } from "assets/icons/portfolio-overview.svg";
import { MaterialTooltip } from "components/tooltips/MaterialTooltip";
import { useReportsActions, useSelectedBookmarkSelector, useUserActions } from "store";
import { IBookmark, IReportType } from "store/types";
import { reportStateFromQueries } from "utils/reports-state-from-queries";

import { GroupItem } from "./GroupItem";

const reportTooltipType = {
  [IReportType.PORTFOLIO]: "Portfolio Analysis",
  [IReportType.COMPARISON]: "Comparison",
  [IReportType.DEAL_VIEW]: "Report",
  [IReportType.EXTERNAL]: "External report"
};

export const ReportBookmark: React.FC<IBookmark> = ({
  params,
  name,
  id,
  is_default,
  is_private,
  account_default,
  user,
  report_type,
  type
}) => {
  const { push } = useHistory();

  const { replaceQueriesAction } = useReportsActions();
  const { setSelectedBookmark } = useUserActions();
  const selectedBookmark = useSelectedBookmarkSelector();

  const bookmarkPath = params.split("?")[0];

  const goToReport = useCallback(() => {
    if (params && !Array.isArray(params)) {
      setSelectedBookmark(id);
      replaceQueriesAction({ queries: reportStateFromQueries(params)! });
      setTimeout(() => push(bookmarkPath), 0);
    }
  }, [params]);

  return (
    <GroupItem
      icon={
        <MaterialTooltip isShow placement="top" title={report_type && reportTooltipType[report_type]}>
          {report_type === IReportType.DEAL_VIEW ? (
            <AutoGraphIcon sx={{ fontSize: "18px" }} />
          ) : (
            <PortfolioIcon style={{ fill: "#0a3142", width: "18px", height: "18px" }} />
          )}
        </MaterialTooltip>
      }
      title={name}
      id={id}
      ownerData={user}
      isActive={selectedBookmark === id}
      onClick={goToReport}
      allowSetDefault
      isDefault={is_default}
      isPrivate={is_private}
      isAccountDefault={account_default}
      bookmarkType={type}
    />
  );
};
